import React from "react";

type Change = { field: string; from: string; to: string; subject?: string };
type Presentation = {
  title: string;
  changes: Change[];
  details: { label: string; changes: Change[] }[];
  notice?: string | null;
  empty_message: string;
};

function Changes({ rows }: { rows: Change[] }) {
  return (
    <div className="mt-3 overflow-x-auto rounded-lg border border-slate-200">
      <table className="w-full table-fixed text-sm">
        <thead className="bg-slate-50 text-left text-slate-600">
          <tr>
            <th scope="col" className="w-1/2 px-3 py-2 font-medium">Change</th>
            <th scope="col" className="w-1/4 px-3 py-2 font-medium">From</th>
            <th scope="col" className="w-1/4 px-3 py-2 font-medium">To</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200">
          {rows.map((row, index) => (
            <tr key={`${row.field}:${index}`}>
              <th scope="row" className="break-words px-3 py-2 text-left align-top font-medium text-slate-800">
                {row.field}
                {row.subject ? <span className="mt-1 block text-xs font-normal text-slate-600">{row.subject}</span> : null}
              </th>
              <td className="break-words px-2 py-2 align-top text-xs tabular-nums text-slate-600 sm:px-3 sm:text-sm">{row.from}</td>
              <td className="break-words px-2 py-2 align-top text-xs font-medium tabular-nums text-slate-900 sm:px-3 sm:text-sm">{row.to}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function PricingAuditChanges({ presentation }: { presentation: Presentation }) {
  return (
    <section aria-label={presentation.title} className="min-w-0">
      <p className="mt-3 text-sm font-semibold text-slate-900">{presentation.title}</p>
      {presentation.notice ? <p className="mt-1 text-sm text-slate-600">{presentation.notice}</p> : null}
      {presentation.changes.length ? (
        <Changes rows={presentation.changes} />
      ) : presentation.details.length === 0 ? (
        <p className="mt-2 text-sm text-slate-600">{presentation.empty_message}</p>
      ) : null}
      {presentation.details.length ? (
        <details className="mt-3 rounded-lg border border-slate-200 p-3">
          <summary className="cursor-pointer text-sm font-medium text-indigo-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            Affected items and calculation details ({presentation.details.length})
          </summary>
          <div className="mt-3 space-y-4">
            {presentation.details.map((detail, index) => (
              <section key={`${detail.label}:${index}`} aria-label={detail.label}>
                <p className="break-words text-sm font-medium text-slate-800">{detail.label}</p>
                <Changes rows={detail.changes} />
              </section>
            ))}
          </div>
        </details>
      ) : null}
    </section>
  );
}
